import { Dayjs } from "dayjs";

export const formatDayJSToDateString = (dayJSDate?: Dayjs) => {
  return dayJSDate?.format("YYYY-MM-DD") || "";
};
